import React, { Component } from 'react';

class SearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: ''
    };
    this.inputRef = React.createRef();
    
    // Привязываем методы к экземпляру класса
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    // Автоматический фокус на поле ввода при открытии
    if (this.inputRef.current) {
      this.inputRef.current.focus();
    }
  }

  handleInputChange(e) {
    this.setState({ query: e.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.state.query.trim()) {
      this.props.onSearch(this.state.query.trim());
    }
  }

  handleKeyDown(e) {
    // Закрытие по Escape
    if (e.key === 'Escape') {
      this.props.onClose();
    }
  }

  render() {
    const { query } = this.state;

    return (
      <form 
        onSubmit={this.handleSubmit}
        className="w-[320px] bg-white rounded-xl p-4 shadow-2xl border border-gray-200"
      >
        <div className="relative">
          <input
            ref={this.inputRef}
            type="text"
            value={query}
            onChange={this.handleInputChange}
            onKeyDown={this.handleKeyDown}
            placeholder="Поиск по сайту..."
            className="w-full h-[50px] bg-gray-100 text-gray-800 placeholder-gray-400 rounded-lg pl-4 pr-12 outline-none focus:ring-2 focus:ring-[#009EE3] focus:bg-white transition-all"
            autoComplete="off"
          />
          <button
            type="submit"
            className="absolute right-2 top-1/2 -translate-y-1/2 w-[36px] h-[36px] rounded-full bg-[#009EE3] hover:bg-[#0077b3] transition-colors duration-300 flex items-center justify-center shadow-md"
            aria-label="Найти"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.5 14.5L11.5 10.5C12.5 9.3 13 7.8 13 6.2C13 2.9 10.3 0.2 7 0.2C3.7 0.2 1 2.9 1 6.2C1 9.5 3.7 12.2 7 12.2C8.6 12.2 10.1 11.7 11.3 10.8L15.3 14.8L15.5 14.5ZM7 11.2C4.2 11.2 2 9 2 6.2C2 3.4 4.2 1.2 7 1.2C9.8 1.2 12 3.4 12 6.2C12 9 9.8 11.2 7 11.2Z" fill="white"/>
            </svg>
          </button>
        </div>
        
        {/* Подсказка для поиска */}
        <div className="text-xs text-gray-500 mt-3 px-1">
          Нажмите Enter для поиска
        </div>
        
        {query.length > 0 && query.length < 3 && (
          <p className="text-red-500 text-xs mt-2 font-medium">
            ⚠️ Минимум 3 символа
          </p>
        )}
      </form>
    );
  }
}

export default SearchForm;